import React from "react";
import PropTypes from "prop-types";

export const ITXImage = ({
  id,
  name,
  width,
  height,
  className = "",
  style = {},
  alt = "",
  loading = "lazy",
  url = "",
}) => {
  if (!id || !name || !width || !height) return null;

  return (
    <img
      src={url}
      alt={alt ? alt : name}
      style={style}
      className={className}
      width={width}
      height={height}
      loading={loading}
    />
  );
};

ITXImage.prototype = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  className: PropTypes.string,
  alt: PropTypes.string,
  style: PropTypes.object,
  loading: PropTypes.string,
  url: PropTypes.string,
};
